// Dynamically import all *ConfigConfig.tsx files from the app folder
import { FuseRouteConfigType, FuseRoutesType } from '@fuse/utils/FuseUtils';
import { Navigate } from 'react-router-dom';
import FuseLoading from '@fuse/core/FuseLoading';
import ErrorBoundary from '@fuse/utils/ErrorBoundary';
import { layoutConfigOnlyMain } from './layoutConfigTemplates';
import settingsConfig from './settingsConfig';
import App from '@/app/App';
import Error404Page from '@/app/(public)/404/Error404Page';
import Error401Page from '@/app/(public)/401/Error401Page';
import OpeningPageRedirect from '@/components/OpeningPageRedirect';
import FeedbackBoard from '@/app/feedback/FeedbackBoard';

const configModules: Record<string, unknown> = import.meta.glob('/src/app/**/*Route.tsx', {
  eager: true
});

const mainRoutes: FuseRouteConfigType[] = Object.keys(configModules)
  .map((modulePath) => {
    const moduleConfigs = (configModules[modulePath] as { default: FuseRouteConfigType | FuseRouteConfigType[] })
      .default;
    return Array.isArray(moduleConfigs) ? moduleConfigs : [moduleConfigs];
  })
  .flat();

const routes: FuseRoutesType = [
  { path: '/feedback', element: <FeedbackBoard />, auth: null },
  {
    path: '/',
    element: <App />,
    auth: settingsConfig.defaultAuth,
    errorElement: <ErrorBoundary />,
    children: [
      {
        // "Home" resolves to the opening page chosen in Account settings (dashboard by default).
        path: '/',
        element: <OpeningPageRedirect />
      },

      ...mainRoutes,
      {
        path: 'loading',
        element: <FuseLoading />,
        settings: { layout: layoutConfigOnlyMain }
      },
      {
        path: '401',
        element: <Error401Page />
      },
      {
        path: '404',
        element: <Error404Page />,
        settings: { layout: layoutConfigOnlyMain },
        auth: null
      }
    ]
  },
  {
    path: '*',
    element: <Navigate to="404" />
  }
];

// The feedback hostname is a standalone product surface, without Director's app shell.
export default window.location.hostname.toLowerCase() === 'feedback.director.services'
  ? [{ path: '*', element: <FeedbackBoard />, auth: null }]
  : routes;
